export default __webpack_public_path__ + "navigation-examples-route-deserialize-v1-1200-e66a393b41acaece3342fa6b21b039c4.webp";